const bfReduceCartItems = (lines) => {
    const newData = [];

    lines.forEach((line, index) => {
        const objCopy = structuredClone(line);
        const {id, variant_id, key, properties, quantity} = objCopy;
        
        newData.push({id, variant_id, line: index + 1, key, properties, quantity})
    });

    return newData;
}

async function processItems(items, index = 0) {
    if (index >= items.length) {
        return;
    }

    const {line, properties, quantity} = items[index];

    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({line, properties, quantity})
    };

    try {
        const resp = await fetch('/cart/change.js', config);
        const data = await resp.json();
        //console.log(`processItems -- ${index} --`, data.items); // Можно обработать или сохранить результат по необходимости

        await processItems(items, index + 1);
    } catch (error) {
        console.error('Error processing item:', error);
    }
}

async function bfUpdateCartProperty(cartObject = null, callback = function () {}) {
    const shippingBarReady = document.querySelector('[data-shipping-bar="ready"]');
    if (!shippingBarReady) return;

    const isFreeShipping = !shippingBarReady.classList.contains('hidden');
    let cartData = cartObject;

    if (!cartData) {
        const response = await fetch('/cart.js');
        cartData = await response.json();
    }

    const cartItems = cartData.items;

    const newData = bfReduceCartItems(cartItems);
    const hasCustomProperties = newData.some(item => item?.properties?.__znsfs);

    if (!isFreeShipping && !hasCustomProperties) {
        callback();
        return;
    }

    if (isFreeShipping) {
        newData.map(item => {
            item.properties['__znsfs'] = 'true'
            if (item.properties['__bf']) {
                delete item.properties['__bf'];
            }
        });
    } else if (!isFreeShipping && hasCustomProperties) {
        newData.map(item => {
            if (item.properties['__znsfs']) {
                item.properties['__bf'] = 'true';
                delete item.properties['__znsfs'];
            }
        })
    }

    await processItems(newData);
    callback();
}

class CartCheckout extends HTMLElement {
    constructor() {
        super();
        
        this.button = this.querySelector('button[type="submit"][name="checkout"]');
        this.isClickHandler = false;
        // Problem with reload page after we came back from checkout to the cart page
        //bfUpdateCartProperty(null, () => {});
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.addEventListener('click', (event) => {
            if (this.isClickHandler) return;

            this.clickHandler(event);
        });
    }

    async clickHandler(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.button.disabled = true;
        this.button.classList.add('loading');

        await bfUpdateCartProperty(null, () =>      {
            this.button.classList.remove('loading');
            this.button.disabled = false;
            this.isClickHandler = true;
            this.button.click();
        });
    }
}

customElements.define('cart-checkout', CartCheckout);

